<template>
  <v-container>
    <div class="panel" v-if="items.length">
      <v-container>
        <v-row align="center" class="mb-1">
          <div style="display: flex; justify-items: start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  elevation="0"
                  class="ml-2"
                  @click="openAllFCT()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon class="rotateBTN" :class="{ rotate: openAll }">
                    mdi-menu-right
                  </v-icon>
                </v-btn>
              </template>
              <span>
                {{
                  this.openAll
                    ? $t("component.closeAll")
                    : $t("component.openAll")
                }}
              </span>
            </v-tooltip>
          </div>
          <v-text-field
            v-model="search"
            class="mx-2"
            :label="$t('fav.searchRule')"
            outlined
            clearable
            hide-details
            clear-icon="mdi-close-circle-outline"
          ></v-text-field>
        </v-row>
      </v-container>
      <v-treeview
        :items="items"
        open-on-click
        activatable
        active-class="activerule"
        item-key="name"
        :active="active"
        :search="search"
        :open.sync="open"
      >
        <template slot="label" slot-scope="{ item }">
          <v-row
            class="mx-4 my-2"
            align="center"
            style="height: 40px"
            @click="getRule(item)"
          >
            <div v-if="!item.children" style="width: 30px; padding-left: 4px">
              <v-icon class="fav" v-if="isRuleFav(item.id)"> mdi-heart </v-icon>
              <v-icon class="nofav" v-else> mdi-heart </v-icon>
            </div>
            <app-flag :from="item.origin"></app-flag>
            <p style="margin: 0">{{ item.name }}</p>
          </v-row>
        </template>
      </v-treeview>
    </div>
    <div v-else>
      <v-skeleton-loader
        v-if="loader"
        type="article, image, article, image"
      ></v-skeleton-loader>
      <div v-else>Pas de données</div>
    </div>
  </v-container>
</template>

<style>
/* refonte du composant via pure css */
.panel > .v-treeview > .v-treeview-node {
  border: 1px solid #ca0538;
  border-radius: 4px;
  margin: 5px;
}
.panel > .v-treeview > .v-treeview-node > .v-treeview-node__root {
  background-color: #ca0538;
  color: white;
  font-weight: 400;
  font-size: 20px;
  font-stretch: expanded;
  letter-spacing: 2px;
}

.panel > .v-treeview > .v-treeview-node > .v-treeview-node__root > button {
  color: white;
}

.v-treeview-node__level {
  width: 0px !important;
}

.nofav {
  color: transparent !important;
}

.fav {
  color: rgba(202, 5, 56, 1) !important;
}

/* ACTIVE RULE */
.activerule {
  background-color: rgba(180, 7, 30, 0.1);
}
.activerule .row {
  font-weight: 900;
  color: rgba(202, 5, 56, 1);
}

.v-treeview-node__label {
  white-space: inherit !important;
}
.v-treeview-node__label .row {
  flex-wrap: nowrap;
}
.rotateBTN {
  transition: transform 0.3s ease-in-out !important;
}
.rotateBTN.rotate {
  transform: rotate(90deg);
}
</style>

<script>
import { mapGetters } from "vuex";
import AppFlag from "./AppFlag.vue";

export default {
  data: () => ({
    search: null,
    loader: true,
    active: [],
    open: [],
    openAll: false,
  }),
  model: {
    prop: "activeRuleId",
    event: "getRule",
  },
  props: {
    activeRuleId: Object,
    items: Array,
  },
  computed: {
    // rules fav = array of ID
    ...mapGetters(["rules_fav", "currentPage"]),
  },
  components: {
    AppFlag,
  },
  beforeMount() {
    // for sub ?
    if (this.activeRuleId) {
      this.$emit("getRule", this.activeRuleId);
      if (this.currentPage.name === this.$route.name) {
        if (this.currentPage.params.rule) {
          this.active.push(this.currentPage.params.rule.name);
        }
        if (this.currentPage.params.theme) {
          this.open.push(this.currentPage.params.theme);
        }
      } else {
        if (this.$route.params.rule) {
          this.active.push(this.$route.params.rule.name);
        }
        if (this.$route.params.theme) {
          this.open.push(this.$route.params.theme);
        }
      }
    }
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
  methods: {
    isRuleFav(id) {
      let a = true;
      if (this.rules_fav.indexOf(id) < 0) {
        a = false;
      }
      return a;
    },
    getRule(item) {
      if (!item.totalRules) {
        this.$emit("getRule", item);
      }
    },
    openAllFCT() {
      this.openAll = !this.openAll;
      this.$children[2].updateAll(this.openAll);
    },
  },
  watch: {
    search(value) {
      // OPEN PANEL WHEN SEARCH
      if (value === null || !value.length) {
        this.openAll = true;
      } else {
        this.openAll = false;
      }
      this.openAllFCT();
    },
    open(value) {
      console.log(value);
      if (value.length > 0) {
        this.openAll = true;
      } else {
        this.openAll = false;
      }
      console.log(this.openAll);
    },
  },
};
</script>